import {Alert, Typography} from "@material-tailwind/react";
import React from "react";

export function AgentBranchDocumentAlert() {
  return (
    <Alert className="w-full" variant="gradient">
      <Typography className="w-full">
        کاربر گرامی:
      </Typography>
      <Typography className="w-full">
        <li>
          از طریق دکمه جدید برای خدمات خود لیست مدارک مورد نیاز را تعریف نمائید.
        </li>
        <li>
          لطفا مدارک اولیه و ضروری که برای پاسخ دهی به استعلام قیمت کاربر به آنها نیاز دارید را تعریف نمائید.
        </li>
        <li>
          با معرفی لیست مدارک اولیه و ضروری کاربران، عملکرد و انتخاب بهتری را خواهند داشت.
        </li>
        <li>
          لطفا برای مدارک و مستنداتی که قابل فهم نیستند، توضیحات کوتاهی را درج نمائید.
        </li>
      </Typography>
    </Alert>
  )
}
